import { ZoneId as ZoneId } from '@js-joda/core';
import { toSet1glep2u1u9tcb as toSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getAvailableZoneIdsSet() {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = ZoneId.getAvailableZoneIds();
  return toSet(tmp$ret$1);
}
//region block: exports
export {
  getAvailableZoneIdsSet as getAvailableZoneIdsSet2qkom0nd2ncgs,
};
//endregion

//# sourceMappingURL=PlatformSpecifics.mjs.map
